"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Info_1 = require("../../../gen-src/icons/Info");
var Localize_1 = require("../../../gen-src/Localize");
var VizClientFieldCardStyles_1 = require("./VizClientFieldCardStyles");
var VizClientFieldCardDescription = /** @class */ (function (_super) {
    __extends(VizClientFieldCardDescription, _super);
    function VizClientFieldCardDescription() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VizClientFieldCardDescription.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        var field = this.props.field;
        if (field.description) {
            return React.createElement(DirectDescription, { description: field.description });
        }
        var column = maybeGetColumnFromField(field);
        if (column) {
            if (column.description) {
                return React.createElement(ColumnDescription, { column: column });
            }
            if (((_d = (_c = (_b = (_a = column.referencedByFlowColumnOutputField) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.parentFields) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.__typename) === 'FlowColumnInputField') {
                var upstreamColumn = (_h = (_g = (_f = (_e = column.referencedByFlowColumnOutputField) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.parentFields) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.column;
                if ((_j = upstreamColumn) === null || _j === void 0 ? void 0 : _j.description) {
                    return React.createElement(ColumnDescription, { column: upstreamColumn });
                }
            }
        }
        if (field.__typename === 'DatasourceField') {
            var remoteField = field.remoteField;
            if (remoteField) {
                if (remoteField.description) {
                    return React.createElement(RemoteFieldDescription, { remoteField: remoteField });
                }
                var remoteColumn = maybeGetColumnFromField(remoteField);
                if (remoteColumn && remoteColumn.description) {
                    return React.createElement(RemoteColumnDescription, { remoteColumn: remoteColumn, remoteField: remoteField });
                }
                if (((_o = (_m = (_l = (_k = remoteField.referencedByFlowFieldOutputField) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.parentFields) === null || _m === void 0 ? void 0 : _m[0]) === null || _o === void 0 ? void 0 : _o.__typename) === 'FlowColumnInputField') {
                    var remoteUpstreamColumn = (_s = (_r = (_q = (_p = remoteField.referencedByFlowFieldOutputField) === null || _p === void 0 ? void 0 : _p[0]) === null || _q === void 0 ? void 0 : _q.parentFields) === null || _r === void 0 ? void 0 : _r[0]) === null || _s === void 0 ? void 0 : _s.column;
                    if ((_t = remoteUpstreamColumn) === null || _t === void 0 ? void 0 : _t.description) {
                        return React.createElement(RemoteColumnDescription, { remoteColumn: remoteUpstreamColumn, remoteField: remoteField });
                    }
                }
            }
        }
        return React.createElement(NoDescription, null);
    };
    return VizClientFieldCardDescription;
}(React.PureComponent));
exports.VizClientFieldCardDescription = VizClientFieldCardDescription;
function DirectDescription(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(DescriptionTitle, null),
        React.createElement(VizClientFieldCardStyles_1.FieldCardDetailText, null, props.description)));
}
function ColumnDescription(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(DescriptionTitle, { sourceColumn: props.column }),
        React.createElement(VizClientFieldCardStyles_1.FieldCardDetailText, null, props.column.description)));
}
function RemoteFieldDescription(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(DescriptionTitle, { sourceField: props.remoteField }),
        React.createElement(VizClientFieldCardStyles_1.FieldCardDetailText, null, props.remoteField.description)));
}
function RemoteColumnDescription(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(DescriptionTitle, { sourceColumn: props.remoteColumn, sourceField: props.remoteField }),
        React.createElement(VizClientFieldCardStyles_1.FieldCardDetailText, null, props.remoteColumn.description)));
}
function NoDescription() {
    return (React.createElement(React.Fragment, null,
        React.createElement(DescriptionTitle, null),
        React.createElement(VizClientFieldCardStyles_1.NoDescriptionPlaceholder, null, Localize_1.Messages.NoDescriptionAvailable())));
}
function DescriptionTitle(props) {
    return (React.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitleWrapper, null,
        React.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitle, null,
            Localize_1.Messages.Description(),
            React.createElement(DescriptionInfo, __assign({}, props)))));
}
function DescriptionInfo(props) {
    var column = props.sourceColumn;
    var field = props.sourceField;
    if (column || field) {
        var getDescriptionTooltipContent = function () {
            if (column && field) {
                return Promise.resolve(React.createElement(VizClientFieldCardStyles_1.DescriptionTooltipText, null, data_catalog_shared_1.interpolateString(Localize_1.Messages.DescriptionInfoInheritedFromColumnThoughField({
                    column: '[COLUMN]',
                    table: '[TABLE]',
                    field: '[FIELD]',
                }), {
                    COLUMN: React.createElement(ColumnLink, { key: 'column-link', column: column }),
                    TABLE: React.createElement(TableLink, { key: 'table-link', table: column.table }),
                    FIELD: React.createElement(FieldLink, { key: 'field-link', remoteField: field }),
                })));
            }
            else if (field) {
                return Promise.resolve(React.createElement(VizClientFieldCardStyles_1.DescriptionTooltipText, null, data_catalog_shared_1.interpolateString(Localize_1.Messages.DescriptionInfoInheritedFromField({
                    field: '[FIELD]',
                }), {
                    FIELD: React.createElement(FieldLink, { key: 'field-link', remoteField: field }),
                })));
            }
            else if (column) {
                return Promise.resolve(React.createElement(VizClientFieldCardStyles_1.DescriptionTooltipText, null, data_catalog_shared_1.interpolateString(Localize_1.Messages.DescriptionInfoInheritedFromColumn({
                    column: '[COLUMN]',
                    table: '[TABLE]',
                }), {
                    COLUMN: React.createElement(ColumnLink, { key: 'column-link', column: column }),
                    TABLE: React.createElement(TableLink, { key: 'table-link', table: column.table }),
                })));
            }
            else {
                return Promise.resolve(null);
            }
        };
        return (React.createElement("span", { className: VizClientFieldCardStyles_1.fieldCardDetailTitleIconClass },
            React.createElement(widgets_1.ChromeTooltipWidget, { getContent: getDescriptionTooltipContent, width: 300 },
                React.createElement(Info_1.SvgInfo, null))));
    }
    else {
        return null;
    }
}
function ColumnLink(props) {
    return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(widgets_1.TextLinkWidget, { testId: 'description-tooltip-column-link', href: maybeColumnUrl(props.column, urls), target: '_blank' }, props.column.name);
    }));
}
function maybeColumnUrl(column, urls) {
    return column.table
        ? urls.catalogTableColumnUrl(column.table.id, column.id)
        : '';
}
function TableLink(props) {
    return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(widgets_1.TextLinkWidget, { testId: 'description-tooltip-table-link', href: maybeTableUrl(props.table, urls), target: '_blank' }, props.table ? props.table.name : '');
    }));
}
function maybeTableUrl(table, urls) {
    return table
        ? urls.catalogTableUrl(table.id)
        : '';
}
function FieldLink(props) {
    return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(widgets_1.TextLinkWidget, { testId: 'description-tooltip-field-link', href: maybeFieldUrl(props.remoteField, urls), target: '_blank' }, props.remoteField.name);
    }));
}
function maybeFieldUrl(remoteField, urls) {
    return remoteField.datasource && remoteField.datasource.__typename === 'PublishedDatasource'
        ? urls.datasourceLineageFieldUrl(remoteField.datasource.vizportalUrlId, remoteField.id)
        : '';
}
function maybeGetColumnFromField(field) {
    if (field.__typename === 'ColumnField') {
        var columnsConnection = field.columnsConnection;
        if (columnsConnection) {
            var columns = columnsConnection.nodes;
            if (columns && columns.length > 0) {
                var column = columns[0];
                if (column) {
                    return column;
                }
            }
        }
    }
    return null;
}
//# sourceMappingURL=VizClientFieldCardDescription.js.map